export type SearchParams = Record<string, string | string[] | undefined>;

export function isPreview(searchParams?: SearchParams): boolean {
  // Environment-based preview (e.g., preview deployment)
  if (process.env.NEXT_PUBLIC_IS_PREVIEW?.toLowerCase() === 'true') {
    return true;
  }

  // Builder preview mode (from URL params)
  if (searchParams) {
    const builderPreview = searchParams['builder.preview'];
    const builderEditing = searchParams['__builder_editing__'];
    if (builderPreview || builderEditing === 'true') {
      return true;
    }
  }

  return false;
}
